/**
 * DevExtreme (esm/ui/collection/ui.collection_widget.edit.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import CollectionWidget from "../../__internal/ui/collection/collection_widget.edit";
export default CollectionWidget;